import React from "react"
import { useToggle } from "utils/Hooks"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import L10n from "../../../lib/carrot-l10n"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { H3 } from "@carrotfertility/carotene"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { useSelector } from "react-redux"
import { getHasCostShare } from "derivedSelectors"
import { getHasDeductible } from "derivedSelectors/deductibleSelectors"
import { HowMuchReimbursedModalContainer } from "../../containers/reimbursements/educationmodal/HowMuchReimbursedModalContainer"
import { getSupportCenterLink, SupportCenterLinks } from "../../../utils/SupportCenterLinks"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const HowMuchReimbursedLink = ({ toggleShowHowMuchReimbursedModal }) => (
  <>
    <ArrowLink onClick={toggleShowHowMuchReimbursedModal}>{l`How much will I be reimbursed?`}</ArrowLink>
    <Spacer height={0.25} />
  </>
)

const SupportModule = () => {
  const [showHowMuchReimbursedModal, toggleShowHowMuchReimbursedModal] = useToggle()
  const hasCostShare = useSelector(getHasCostShare)
  const hasDeductible = useSelector(getHasDeductible)

  const showReimbursement = hasDeductible || hasCostShare

  return (
    <>
      <RoundedRectangle backgroundColor="near-white">
        <RRIconBar iconBackgroundColor="white-60" iconName="icn-help" />
        <H3 variant="primary" stack="tiny">{l`client.reimbursements.support.NeedHelp`}</H3>

        <ArrowLink to="/your-benefit-guide/coverage">{l`client.reimbursements.support.WhatsEligible`}</ArrowLink>
        <Spacer height={0.25} />

        {showReimbursement && (
          <HowMuchReimbursedLink toggleShowHowMuchReimbursedModal={toggleShowHowMuchReimbursedModal} />
        )}
        <ArrowLink
          to={getSupportCenterLink(SupportCenterLinks.WHAT_SHOULD_MY_ITEMIZED_STATEMENT_INCLUDE)}
        >{l`client.reimbursements.include.answersAboutReimbursement`}</ArrowLink>
        <Spacer height={1.5} />
        <H3 variant="primary" stack="tiny">{l`Wondering about taxation?`}</H3>
        <ArrowLink
          to={getSupportCenterLink(SupportCenterLinks.CARROT_AND_TAXES)}
        >{l`Learn about Carrot and taxes`}</ArrowLink>
        <Spacer height={1.5} />
        <H3 variant="primary" stack="tiny">{l`client.reimbursements.support.MoreQuestions`}</H3>
        <ArrowLink to="/talk-to-carrot">{l`client.reimbursements.support.TalkToCarrot`}</ArrowLink>
      </RoundedRectangle>

      {showHowMuchReimbursedModal && <HowMuchReimbursedModalContainer onExit={toggleShowHowMuchReimbursedModal} />}
    </>
  )
}

export { SupportModule }
